export default [
  {
    mark: 0,
    icon: 'fas fa-ban',
    text: 'ban',
    color: 'red' //'var(--color-red)'
  },
  {
    mark: 1,
    icon: 'fas fa-minus',
    text: 'minus',
    color: 'red' //'var(--color-red)'
  },
  {
    mark: 2,
    icon: 'fas fa-plus',
    text: 'plas',
    color: 'green', //'var(--color-green)'
    class: 'mark-alt-color'
  },
  {
    mark: 3,
    icon: 'fas fa-check',
    text: 'check',
    color: 'green', //'var(--color-green)'
    class: 'mark-alt-color'
  },
  {
    mark: 4,
    icon: 'fas fa-pause',
    text: 'pause',
    color: 'graphite' //'var(--color-graphite)'
  },
  {
    mark: 5,
    icon: 'fas fa-heart',
    text: 'heart',
    color: 'red' //'var(--color-red)'
  },
  {
    mark: 6,
    icon: 'fas fa-star',
    text: 'star',
    color: 'tangerine' //'var(--color-tangerine)'
  },
  {
    mark: 7,
    icon: 'far fa-trash-alt',
    text: 'heart',
    color: 'graphite' //'var(--color-graphite)'
  },
];